import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";
import Create from "views/TFSFee/Create";
import Delete from "views/TFSFee/Delete";
import Edit from "views/TFSFee/Edit";
import List from "views/TFSFee/List";

import { token } from "functions/Helper";

const tfsFee = () => {
  let views = [];

  if (token["booking.tfs_fees.read"] === "allowed" || token.is_admin === "True")
    views.push({
      path: "/TFSFees/List",
      name: "TFS Fees",
      icon: LocalGasStationIcon,
      component: List,
      layout: "/admin"
    });

  return views;
};

const tfsFeeHidden = () => {
  let views = [];

  if (
    token["booking.tfs_fees.write"] === "allowed" ||
    token.is_admin === "True"
  )
    views = views.concat([
      {
        path: "/TFSFees/Create",
        name: "Create TFS Fee",
        component: Create,
        layout: "/admin"
      },
      {
        path: "/TFSFees/Edit",
        name: "Edit TFS Fee",
        component: Edit,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/TFSFees/Delete",
        name: "Delete TFS Fee",
        component: Delete,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "TFS Hidden",
        state: "tfsFeeHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { tfsFee, tfsFeeHidden };
